module.exports = __webpack_public_path__ + "static/img/dayu.bd8d9137.png";